export const JOB_OFFERS_PATH = "/job-offers";
